export enum FeatureToggle {
  catalogAdmin = 'catalogAdmin',
  ShowQasWorkflowActions = 'rt_catalog_admin_show_qas_workflow_actions',
  ShowCampPipelineEditor = 'rt_catalog_admin_show_camp_pipeline_editor',
}
